<template>
    <section aria-label="Piano di trattamento, azione e verifica" class="nc-plan">
        <h3 class="t-title-3">Responsabili e termini</h3>
        <v-row dense>
            <v-col cols="12" md="4"><v-text-field :value="value.trattamento_responsabile" @input="update('trattamento_responsabile', $event)" label="Responsabile del trattamento" outlined dense /></v-col>
            <v-col cols="12" md="4"><v-text-field :value="value.trattamento_scadenza" @input="update('trattamento_scadenza', $event)" label="Termine del trattamento" type="date" outlined dense clearable /></v-col>
            <v-col cols="12" md="4"><v-text-field :value="value.trattamento_eseguito_il" @input="update('trattamento_eseguito_il', $event)" label="Trattamento eseguito il" type="date" outlined dense clearable /></v-col>
        </v-row>
        <v-row v-if="!noAction" dense>
            <v-col cols="12" md="4"><v-text-field :value="value.azione_responsabile" @input="update('azione_responsabile', $event)" label="Responsabile dell’azione correttiva" outlined dense /></v-col>
            <v-col cols="12" md="4"><v-text-field :value="value.azione_scadenza" @input="update('azione_scadenza', $event)" label="Termine dell’azione correttiva" type="date" outlined dense clearable /></v-col>
            <v-col cols="12" md="4"><v-text-field :value="value.azione_eseguita_il" @input="update('azione_eseguita_il', $event)" label="Azione correttiva eseguita il" type="date" outlined dense clearable /></v-col>
        </v-row>
        <h3 class="t-title-3">Verifica dell’efficacia</h3>
        <section class="nc-verification-method" aria-label="Controllo delle spedizioni successive">
            <p class="mc-caption">Controllo delle spedizioni successive</p>
            <p class="nc-method-text">{{ value.verifica_criterio }}</p>
        </section>
        <v-row dense>
            <v-col cols="12" md="6"><v-text-field :value="value.verifica_responsabile" label="Responsabile della verifica" hint="Compilatore della scheda 8D" persistent-hint readonly outlined dense /></v-col>
            <v-col cols="12" md="6"><v-text-field :value="value.verifica_prevista_il" label="Data prevista della verifica" hint="Un anno dalla creazione dell’8D, con controlli ogni mese" persistent-hint type="date" readonly outlined dense /></v-col>
        </v-row>
        <v-text-field :value="value.verifica_stato" label="Esito della verifica mensile" readonly outlined dense />
        <v-alert v-if="value.verifica_controllo && value.verifica_controllo.detail" :type="value.verifica_stato === 'Efficace' ? 'success' : value.verifica_stato === 'Non efficace' ? 'warning' : 'info'" text dense>
            <div v-if="value.verifica_ultimo_controllo_il">Ultimo controllo: {{ formatDate(value.verifica_ultimo_controllo_il) }}</div>
            {{ value.verifica_controllo.detail }}
            <ul v-if="reviewIssues.length"><li v-for="(item, index) in reviewIssues" :key="index">{{ item.numero }}<template v-if="item.consegna"> · DDT {{ item.consegna }}</template></li></ul>
        </v-alert>
        <template v-if="value.verifica_stato !== 'In attesa di verifica'">
            <v-row dense>
                <v-col cols="12" md="6"><v-text-field :value="value.verifica_eseguita_il" label="Verifica eseguita il" type="date" readonly outlined dense /></v-col>
                <v-col cols="12" md="6"><v-text-field :value="value.verifica_riferimento" label="Consegne verificate" readonly outlined dense /></v-col>
            </v-row>
            <v-textarea :value="value.verifica_esito" label="Risultato ed evidenze della verifica" readonly outlined dense auto-grow rows="2" />
        </template>
        <p v-else class="nc-guide text--secondary t-caption">Completa la scheda e registra le date effettive di esecuzione. Il controllo mensile aggiornerà l’esito in base alle nuove consegne e alle NC registrate.</p>
        <v-alert v-if="validationRequested && missing.length" type="warning" dense text role="alert">
            <ul><li v-for="item in missing" :key="item">{{ item }}</li></ul>
        </v-alert>
    </section>
</template>

<script>
import { ncPlanMissing } from "./ncEightDPlan.mjs";
import { date } from "@/assets/mecom/js/format.mjs";
export default {
    name: "NcEightDPlan",
    props: { value: {type: Object, required: true}, noAction: Boolean, validationRequested: Boolean },
    computed: {
        missing() {return ncPlanMissing(this.value, this.noAction);},
        reviewIssues() {return [...(this.value.verifica_controllo?.recurrences || []), ...(this.value.verifica_controllo?.unresolved || [])];},
    },
    methods: { formatDate: date, update(key, value) {this.$emit("input", {...this.value, [key]: value});} },
};
</script>

<style scoped>
.nc-plan { display: grid; gap: var(--space-3); margin-top: var(--space-4); }
.nc-plan h3 { margin: 0; }
.nc-verification-method { padding: var(--space-4); border: 1px solid var(--border); border-radius: var(--radius-sm); background: var(--surface-2); }
.nc-verification-method p { margin: 0; }
.nc-method-text { margin-top: var(--space-2) !important; white-space: normal; overflow-wrap: anywhere; line-height: 1.6; }
</style>
